import { z } from 'zod'
import { SuccessEnvelope, Uuid } from './common.js'

export const SubmitValidationResponse = SuccessEnvelope(
  z.object({
    validation: z.object({
      id: Uuid,
      idea_id: Uuid,
      validator_id: Uuid,
      is_complete: z.boolean(),
    }),
    scores: z.object({
      problem: z.number(),
      solution: z.number(),
      market: z.number(),
      overall: z.number(),
    }),
  }),
)

export const MyValidationResponse = SuccessEnvelope(
  z.object({
    id: Uuid,
    idea_id: Uuid,
    is_complete: z.boolean(),
    answers: z.array(
      z.object({
        question_id: Uuid,
        question_text: z.string().nullable().optional(),
        question_type: z.enum(['rating', 'sentiment']).nullable().optional(),
        rating: z.number().nullable(),
        sentiment: z.string().nullable(),
      }),
    ),
    comment: z.unknown().nullable(),
    created_at: z.union([z.string(), z.date()]).nullable().optional(),
  }),
)

export const PostCommentResponse = SuccessEnvelope(z.object({ id: Uuid }))
export const LikeResponse = SuccessEnvelope(z.unknown())

// Recursive comment thread — top-level comments each carry a `replies` array
// of the same shape. `upvotes` / `has_liked` are computed server-side.
const ThreadComment = z.lazy(() =>
  z.object({
    id: Uuid,
    content: z.string(),
    parent_id: Uuid.nullable(),
    author: z.object({ id: Uuid, full_name: z.string().nullable() }).nullable(),
    created_at: z.union([z.string(), z.date()]).nullable(),
    upvotes: z.number(),
    has_liked: z.boolean(),
    replies: z.array(ThreadComment),
  }),
)

export const CommentsListResponse = SuccessEnvelope(z.array(ThreadComment))
